import React from "react";

interface ConditionalType {
  test: boolean;
  children: React.ReactNode;
}

function Conditional(props: ConditionalType) {
  return <React.Fragment>{props.test ? props.children : null}</React.Fragment>;
}

export default Conditional;
